const readCookie = (name) => {
  const entry = document.cookie.split('; ').find((cookie) => cookie.startsWith(`${name}=`));
  return entry ? decodeURIComponent(entry.slice(name.length + 1)) : undefined;
};

export const openaiAttributionParams = () => {
  const params = { source_url: window.location.href };
  const oppref = readCookie('__oppref');
  const obref = readCookie('__obref');

  if (oppref) params.oppref = oppref;
  if (obref) params.obref = obref;

  return params;
};

export const trackOpenaiLead = (saleId) => {
  if (!saleId || typeof window.oaiq !== 'function') return;

  window.oaiq('measure', 'lead_created', { type: 'customer_action' }, { event_id: `lead_${saleId}` });
};
